










import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {IFloatingFilterParams, IFloatingFilter} from 'ag-grid-community'

@Component
export default class AgGridClearableFloatFilter extends Vue implements IFloatingFilter {

    private value = null;
    private params!: IFloatingFilterParams & { modifiedCriteriaCallback: Function }

    private get column() {
        return this.params.column
    }

    private onClear() {
        this.params.modifiedCriteriaCallback(this.column.getColId())
    }

    private onModifiedValue() {
        this.params.modifiedCriteriaCallback(this.column.getColId(), this.value)
    }

    onParentModelChanged(parentModel: any) {
        this.value = parentModel?.filter || null
    }

}
